var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// <reference path="../Company.tsx" />
import React, { useRef, useState, useEffect } from "react";
import { useFormik } from 'formik';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import styles from './styles.module.scss';
import { Button, InputText } from 'template/lib';
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
var ModalMySignature = function (props) {
    var login = useAuth().login;
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var canvasRef = useRef(null);
    var _a = useState(""), name = _a[0], setName = _a[1];
    var _b = useState(""), base64 = _b[0], setBase64 = _b[1];
    var generateSignature = function (text) {
        var canvas = canvasRef.current;
        if (!canvas)
            return;
        var ctx = canvas.getContext("2d");
        if (!ctx)
            return;
        // Configurar fonte primeiro
        var fontSize = 20;
        ctx.font = "italic " + fontSize + "px 'Pinyon Script', cursive";
        ctx.textBaseline = "top"; // facilita medir a altura do texto
        // Medir tamanho do texto
        var metrics = ctx.measureText(text);
        var textWidth = metrics.width;
        var textHeight = fontSize; // fonte é aproximadamente a altura
        // Ajustar canvas para caber exatamente no texto com pequeno padding
        var padding = 10; // pode reduzir para ficar bem colado
        canvas.width = textWidth + padding * 2;
        canvas.height = textHeight + padding * 2;
        // Resetar contexto após redimensionar canvas
        var ctx2 = canvas.getContext("2d");
        if (!ctx2)
            return;
        // Fundo próximo das letras
        ctx2.fillStyle = "#f9f9f9";
        ctx2.fillRect(0, 0, canvas.width, canvas.height);
        // Texto
        ctx2.font = "italic " + fontSize + "px 'Pinyon Script', cursive";
        ctx2.fillStyle = "#222";
        ctx2.textBaseline = "top";
        ctx2.fillText(text, padding, padding);
    };
    useEffect(function () {
        // Garantir que FontFace existe no ambiente
        if (!("FontFace" in window))
            return;
        var font = new window.FontFace("Pinyon Script", "url(https://fonts.gstatic.com/s/pinyonscript/v21/6xKpdSJbL9-e9LuoeQiDRQR8WOzCw9Y.woff2)");
        font.load().then(function (loadedFont) {
            // Tipagem segura para document.fonts
            if ("fonts" in document) {
                document.fonts.add(loadedFont);
            }
            generateSignature(name);
        });
    }, [name]);
    var handleGenerate = function (name) {
        generateSignature(name);
        handleSaveBase64();
    };
    var handleSaveBase64 = function () {
        var canvas = canvasRef.current;
        if (!canvas)
            return;
        // Ajuste a qualidade entre 0 e 1
        var dataUrl = canvas.toDataURL("image/jpeg", 0.6); // 60% de qualidade
        // Ou use WebP: "image/webp", 0.6
        setBase64(dataUrl);
        console.log("Rubrica Base64:", dataUrl);
    };
    var Save = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/signature/createSignature", {
                        base64: base64
                    }, config).then(function (response) {
                        props.sign(props.idItem);
                        props.handleCloseModalSignature();
                    }).catch(function (error) {
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var formik = useFormik({
        initialValues: {
            name: ''
        },
        onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    handleGenerate(values.name);
                }
                catch (err) {
                    alert('erro');
                }
                return [2 /*return*/];
            });
        }); },
    });
    var columns = 1;
    return (_jsx("div", __assign({ className: 'h-24' }, { children: _jsx(Modal, __assign({ isOpen: props.handleOpenModalSignature, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalSignature, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: "Example Modal" }, { children: _jsxs("div", __assign({ className: '' }, { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: ' font-semibold border-b-2 text-lg' }, { children: "Cria\u00E7\u00E3o da Assinatura" }), void 0), _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handleCloseModalSignature }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsx(InputText, { onChange: formik.handleChange, name: "name", label: "Assinatura", inicialValue: formik.values.name }, void 0) }), void 0), _jsx("div", __assign({ className: "border border-gray-300 bg-gray-50 w-full flex", style: {
                                        display: "flex",
                                        justifyContent: "space-evenly",
                                        alignItems: "center",
                                        height: '60px',
                                    } }, { children: _jsx("canvas", { ref: canvasRef, className: "", style: { display: "block", margin: "0 auto" } }, void 0) }), void 0), _jsxs("div", __assign({ className: styles.flexButton }, { children: [_jsx(Button, __assign({ type: 'submit', className: 'spaceButton' }, { children: "Gerar" }), void 0), _jsx(Button, __assign({ onClick: Save }, { children: "Salvar" }), void 0)] }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
};
export default ModalMySignature;
